export const STORE_USER = "STORE_USER";
export const STORE_USER_DETAILS = "STORE_USER_DETAILS";
export const SET_ATTRIBUTE = "SET_ATTRIBUTE";
